'use strict';

require('./GridItem.scss');

const React = require('react'),
    {Checkbox} = require('material-ui'),
    PropTypes = React.PropTypes;

const GridItem = React.createClass({displayName: "GridItem",
    propTypes: {
        className: PropTypes.string,
        iconClassName: PropTypes.string,
        iconInnerText: PropTypes.string,
        iconId: PropTypes.number,
        isChecked: PropTypes.boolean,
        onCheck: PropTypes.func,
        label: PropTypes.string,
        urlImage: PropTypes.string,
        showCheck: PropTypes.bool
    },

    componentWillReceiveProps(nextProps) {
        if (this.refs.inputCheckbox) {
            this.refs.inputCheckbox.setChecked(nextProps.isChecked);
        }
    },

    componentDidMount() {
        if (this.refs.inputCheckbox) {
            this.refs.inputCheckbox.setChecked(this.props.isChecked);
        }
    },

    onCheck() {
        if (this.props.onCheck) {
            this.props.onCheck(this.props);
        }
    },

    _handleKeyPress(evt) {
        if (evt.key === 'Enter' || evt.key === ' ') {
            this.onCheck();
        }
    },

    _getImage(urlImage) {
        return (urlImage && urlImage) !== ''
            ? React.createElement("img", {className: "bp-grid-item__checkbox-image", src: urlImage})
            : null; // prevent show broken image element
    },

    _getIcon(iconClassName, iconInnerText) {
        return (
            React.createElement("i", {className: `bp-grid-item__icon ${iconClassName ? ' ' + iconClassName : ''}`}, 
                iconInnerText ? iconInnerText : null
            )
        );
    },

    render() {
        const {label, urlImage, isChecked, showCheck, className, iconClassName, iconInnerText} = this.props;

        const haveUrlImage = !!urlImage;
        const imageEl = haveUrlImage ? this._getImage(urlImage) : this._getIcon(iconClassName, iconInnerText);

        let classNameEl, classNameLabel;

        if (isChecked) {
            classNameLabel = 'bp-grid-item__label bp-grid-item__label--checked';
            classNameEl = 'bp-grid-item__checkbox bp-grid-item__checkbox--checked';
        } else {
            classNameLabel = 'bp-grid-item__label';
            classNameEl = 'bp-grid-item__checkbox';
        }

        if (className) {
            classNameEl = `${classNameEl} ${className}`;
        }

        const checkEl = showCheck
            ? React.createElement("div", {
                className: "bp-grid-item bp-grid-item--checked pull-left", 
                "data-should-focus": "true", 
                tabIndex: "0", 
                onKeyPress: this._handleKeyPress
            }, 
                React.createElement("div", {className: classNameEl}, 
                    React.createElement(Checkbox, {onCheck: this.onCheck, ref: "inputCheckbox"}), 
                    imageEl
                ), 
                React.createElement("label", {className: "bp-grid-item__label"}, label)
            )
            : React.createElement("div", {
                className: "bp-grid-item pull-left", 
                "data-should-focus": "true", 
                tabIndex: "0", 
                onKeyPress: this._handleKeyPress, 
                onClick: this.onCheck
            }, 
                React.createElement("div", {className: classNameEl}, 
                    imageEl
                ), 
                React.createElement("label", {className: classNameLabel}, label)
            );

        return checkEl;
    }
});

module.exports = GridItem;



/** WEBPACK FOOTER **
 ** ./src/components/Commons/GridItem/GridItem.jsx
 **/